// extracted by mini-css-extract-plugin
export var icon = "_5b-1";
export var subtext = "_5b-0";